module.exports = __webpack_public_path__ + "img/bottomSon.7a87722b.svg";